<div class="booking-form__error-message" *ngIf="(withValidationErrors$ | async) === true">
  <lx-form-error-message ngProjectAs="additional-info"></lx-form-error-message>
</div>
<div #bookingForm>
  <lx-tell-us-about-you-section
    #tellUsAboutYouForm
    [formType]="formType"
    [sectionIndex]="tellUsAboutYouSectionIndex"
    [validationRequests]="validationRequests"
  ></lx-tell-us-about-you-section>

  <lx-extras-selection class="form-field__single-border-input" [schoolType]="schoolType" [sectionIndex]="tellUsAboutYouSectionIndex + 1"></lx-extras-selection>

  <lx-contact-person-section
    #contactPersonForm
    class="form-field__single-border-input"
    [schoolType]="schoolType"
    [sectionIndex]="tellUsAboutYouSectionIndex + 2"
    [validationRequests]="validationRequests"
  ></lx-contact-person-section>

  <lx-terms-and-promotions-form-section #termsAndPromotionsForm></lx-terms-and-promotions-form-section>
</div>
